<template>
  <!-- エラー表示は必ずv-ifを持つので、例外的に自身の表示処理も持たせる -->
  <div v-if="text" class="text-red-500 text-xs">
    {{ text }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SurveyErrorText',
  props: {
    text: {
      type: String,
      default: undefined,
    },
  },
});
</script>
